import { createFileRoute } from "@tanstack/react-router"

import { AddPaymentMethodRouteComponent } from "@/routes/_authenticated/account/saved-payment-methods/add"
import { walletSetupIntentOptions } from "@/utilities/hooks/queries/user"
import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/saved-payment-methods/add"
)({
  beforeLoad: ({ context }) => {
    context.queryClient.ensureQueryData(walletSetupIntentOptions())
  },
  loader: () => {
    return {
      crumb: {
        translationKey: "common:account.savedPaymentMethods.header",
      } as Crumb,
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <AddPaymentMethodRouteComponent />
}
